/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The OrgWithRoleAndUserPayloadModel model module.
 * @module model/OrgWithRoleAndUserPayloadModel
 * @version v1.0.0
 */
class OrgWithRoleAndUserPayloadModel {
    /**
     * Constructs a new <code>OrgWithRoleAndUserPayloadModel</code>.
     * @alias module:model/OrgWithRoleAndUserPayloadModel
     * @param organizationId {Number} organization Id  (required)
     * @param roleId {Number} role Id  (required)
     * @param userId {Number} user Id  (required)
     */
    constructor(organizationId, roleId, userId) { 
        
        OrgWithRoleAndUserPayloadModel.initialize(this, organizationId, roleId, userId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, organizationId, roleId, userId) { 
        obj['organizationId'] = organizationId;
        obj['roleId'] = roleId;
        obj['userId'] = userId;
    }

    /**
     * Constructs a <code>OrgWithRoleAndUserPayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrgWithRoleAndUserPayloadModel} obj Optional instance to populate.
     * @return {module:model/OrgWithRoleAndUserPayloadModel} The populated <code>OrgWithRoleAndUserPayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrgWithRoleAndUserPayloadModel();

            if (data.hasOwnProperty('organizationId')) {
                obj['organizationId'] = ApiClient.convertToType(data['organizationId'], 'Number');
            }
            if (data.hasOwnProperty('roleId')) {
                obj['roleId'] = ApiClient.convertToType(data['roleId'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * organization Id  (required)
 * @member {Number} organizationId
 */
OrgWithRoleAndUserPayloadModel.prototype['organizationId'] = undefined;

/**
 * role Id  (required)
 * @member {Number} roleId
 */
OrgWithRoleAndUserPayloadModel.prototype['roleId'] = undefined;

/**
 * user Id  (required)
 * @member {Number} userId
 */
OrgWithRoleAndUserPayloadModel.prototype['userId'] = undefined;






export default OrgWithRoleAndUserPayloadModel;

